export default __webpack_public_path__ + "static/glassgo-e322b34503abfffc2b639725f2914667.mp3";